import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreenInit } from '../useScreenInit.js';
import { WizardShell } from '../components/WizardShell';
import { TextField } from '../components/form/TextField';
import { PhoneField } from '../components/form/PhoneField';
import { SelectField } from '../components/form/SelectField';
import { RadioGroup } from '../components/form/RadioGroup';
import { CheckboxField } from '../components/form/CheckboxField';
import { YesNoToggle } from '../components/form/YesNoToggle';
import { CurrencyField } from '../components/form/CurrencyField';
import { PercentField } from '../components/form/PercentField';
import { DateField } from '../components/form/DateField';
import { SectionCard } from '../components/form/SectionCard';
import { FieldGrid } from '../components/form/FieldGrid';
const STEPS = [{
  id: 'borrower',
  label: 'Borrower Information'
}, {
  id: 'employment',
  label: 'Employment & Income'
}, {
  id: 'coborrower',
  label: 'Co-Borrower'
}, {
  id: 'property',
  label: 'Subject Property'
}, {
  id: 'mortgage',
  label: 'Current Mortgage'
}, {
  id: 'credit',
  label: 'Credit & Assets'
}, {
  id: 'review',
  label: 'Review & Submit'
}];
const US_STATES = [{
  value: 'AL',
  label: 'Alabama'
}, {
  value: 'AK',
  label: 'Alaska'
}, {
  value: 'AZ',
  label: 'Arizona'
}, {
  value: 'AR',
  label: 'Arkansas'
}, {
  value: 'CA',
  label: 'California'
}, {
  value: 'CO',
  label: 'Colorado'
}, {
  value: 'CT',
  label: 'Connecticut'
}, {
  value: 'DE',
  label: 'Delaware'
}, {
  value: 'FL',
  label: 'Florida'
}, {
  value: 'GA',
  label: 'Georgia'
}, {
  value: 'HI',
  label: 'Hawaii'
}, {
  value: 'ID',
  label: 'Idaho'
}, {
  value: 'IL',
  label: 'Illinois'
}, {
  value: 'IN',
  label: 'Indiana'
}, {
  value: 'IA',
  label: 'Iowa'
}, {
  value: 'KS',
  label: 'Kansas'
}, {
  value: 'KY',
  label: 'Kentucky'
}, {
  value: 'LA',
  label: 'Louisiana'
}, {
  value: 'ME',
  label: 'Maine'
}, {
  value: 'MD',
  label: 'Maryland'
}, {
  value: 'MA',
  label: 'Massachusetts'
}, {
  value: 'MI',
  label: 'Michigan'
}, {
  value: 'MN',
  label: 'Minnesota'
}, {
  value: 'MS',
  label: 'Mississippi'
}, {
  value: 'MO',
  label: 'Missouri'
}, {
  value: 'MT',
  label: 'Montana'
}, {
  value: 'NE',
  label: 'Nebraska'
}, {
  value: 'NV',
  label: 'Nevada'
}, {
  value: 'NH',
  label: 'New Hampshire'
}, {
  value: 'NJ',
  label: 'New Jersey'
}, {
  value: 'NM',
  label: 'New Mexico'
}, {
  value: 'NY',
  label: 'New York'
}, {
  value: 'NC',
  label: 'North Carolina'
}, {
  value: 'ND',
  label: 'North Dakota'
}, {
  value: 'OH',
  label: 'Ohio'
}, {
  value: 'OK',
  label: 'Oklahoma'
}, {
  value: 'OR',
  label: 'Oregon'
}, {
  value: 'PA',
  label: 'Pennsylvania'
}, {
  value: 'RI',
  label: 'Rhode Island'
}, {
  value: 'SC',
  label: 'South Carolina'
}, {
  value: 'SD',
  label: 'South Dakota'
}, {
  value: 'TN',
  label: 'Tennessee'
}, {
  value: 'TX',
  label: 'Texas'
}, {
  value: 'UT',
  label: 'Utah'
}, {
  value: 'VT',
  label: 'Vermont'
}, {
  value: 'VA',
  label: 'Virginia'
}, {
  value: 'WA',
  label: 'Washington'
}, {
  value: 'WV',
  label: 'West Virginia'
}, {
  value: 'WI',
  label: 'Wisconsin'
}, {
  value: 'WY',
  label: 'Wyoming'
}];
export function RefinanceApplication() {
  const navigate = useNavigate();
  const screenInit = useScreenInit();
  const [currentStep, setCurrentStep] = useState(screenInit.currentStep ?? 0);
  const [submitted, setSubmitted] = useState(false);
  // Borrower Info
  const [isVeteran, setIsVeteran] = useState<boolean | null>(null);
  const [disabilityPercent, setDisabilityPercent] = useState('');
  const [email, setEmail] = useState('');
  const [borrowerName, setBorrowerName] = useState('');
  const [isMarried, setIsMarried] = useState<boolean | null>(null);
  const [ssn, setSsn] = useState('');
  const [dob, setDob] = useState('');
  const [creditScore, setCreditScore] = useState('');
  const [homePhone, setHomePhone] = useState('');
  const [cellPhone, setCellPhone] = useState('');
  const [workPhone, setWorkPhone] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [county, setCounty] = useState('');
  const [propertyAddress, setPropertyAddress] = useState('');
  const [propertyCity, setPropertyCity] = useState('');
  const [propertyState, setPropertyState] = useState('');
  const [propertyZip, setPropertyZip] = useState('');
  const [propertyCounty, setPropertyCounty] = useState('');
  // Employment
  const [employerName, setEmployerName] = useState('');
  const [position, setPosition] = useState('');
  const [yearsEmployed, setYearsEmployed] = useState('');
  const [income, setIncome] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [prevEmployerName, setPrevEmployerName] = useState('');
  const [prevPosition, setPrevPosition] = useState('');
  const [prevYearsEmployed, setPrevYearsEmployed] = useState('');
  const [prevIncome, setPrevIncome] = useState('');
  const [prevEmploymentType, setPrevEmploymentType] = useState('');
  const [ssi, setSsi] = useState('');
  const [pension, setPension] = useState('');
  const [vaDisability, setVaDisability] = useState('');
  const [additionalIncome, setAdditionalIncome] = useState('');
  const [nextPayRaise, setNextPayRaise] = useState('');
  const [creditCards, setCreditCards] = useState('');
  const [autoLoans, setAutoLoans] = useState('');
  const [personalLoans, setPersonalLoans] = useState('');
  const [otherDebt, setOtherDebt] = useState('');
  // Co-Borrower
  const [noCoBorrower, setNoCoBorrower] = useState(false);
  const [coBorrowerName, setCoBorrowerName] = useState('');
  const [coBorrowerMarried, setCoBorrowerMarried] = useState<boolean | null>(null);
  const [coBorrowerSsn, setCoBorrowerSsn] = useState('');
  const [coBorrowerDob, setCoBorrowerDob] = useState('');
  const [coBorrowerCreditScore, setCoBorrowerCreditScore] = useState('');
  const [coBorrowerEmployer, setCoBorrowerEmployer] = useState('');
  const [coBorrowerPosition, setCoBorrowerPosition] = useState('');
  const [coBorrowerYears, setCoBorrowerYears] = useState('');
  const [coBorrowerIncome, setCoBorrowerIncome] = useState('');
  const [coBorrowerPrevEmployer, setCoBorrowerPrevEmployer] = useState('');
  const [coBorrowerPrevPosition, setCoBorrowerPrevPosition] = useState('');
  const [coBorrowerPrevYears, setCoBorrowerPrevYears] = useState('');
  const [coBorrowerPrevIncome, setCoBorrowerPrevIncome] = useState('');
  const [coBorrowerSsi, setCoBorrowerSsi] = useState('');
  const [coBorrowerPension, setCoBorrowerPension] = useState('');
  const [coBorrowerVaDisability, setCoBorrowerVaDisability] = useState('');
  const [coBorrowerAdditionalIncome, setCoBorrowerAdditionalIncome] = useState('');
  const [coBorrowerNextPayRaise, setCoBorrowerNextPayRaise] = useState('');
  // Property
  const [occupancy, setOccupancy] = useState('');
  const [yearBuilt, setYearBuilt] = useState('');
  const [squareFootage, setSquareFootage] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [condoApproved, setCondoApproved] = useState<boolean | null>(null);
  // Current Mortgage
  const [lastRefinanceDate, setLastRefinanceDate] = useState('');
  const [purchaseYear, setPurchaseYear] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [estimatedValue, setEstimatedValue] = useState('');
  const [mortgageCompany, setMortgageCompany] = useState('');
  const [currentBalance, setCurrentBalance] = useState('');
  const [currentPayment, setCurrentPayment] = useState('');
  const [clientEstimatedValue, setClientEstimatedValue] = useState('');
  const [escrowed, setEscrowed] = useState<boolean | null>(null);
  const [propertyTaxes, setPropertyTaxes] = useState('');
  const [insurance, setInsurance] = useState('');
  const [pmi, setPmi] = useState('');
  const [hoa, setHoa] = useState('');
  const [interestRate, setInterestRate] = useState('');
  const [loanTerm, setLoanTerm] = useState('');
  const [loanStructure, setLoanStructure] = useState('');
  const [loanType, setLoanType] = useState('');
  const [hasSecondMortgage, setHasSecondMortgage] = useState<boolean | null>(null);
  const [secondLender, setSecondLender] = useState('');
  const [secondBalance, setSecondBalance] = useState('');
  const [secondYearOpened, setSecondYearOpened] = useState('');
  const [secondPayment, setSecondPayment] = useState('');
  const [secondRate, setSecondRate] = useState('');
  const [secondTerm, setSecondTerm] = useState('');
  const [secondStructure, setSecondStructure] = useState('');
  const [helocCashOut, setHelocCashOut] = useState<boolean | null>(null);
  // Credit & Assets
  const [foreclosure, setForeclosure] = useState<boolean | null>(null);
  const [bankruptcy, setBankruptcy] = useState<boolean | null>(null);
  const [bankruptcyChapter, setBankruptcyChapter] = useState('');
  const [childSupport, setChildSupport] = useState<boolean | null>(null);
  const [loanModification, setLoanModification] = useState<boolean | null>(null);
  const [deferredInterest, setDeferredInterest] = useState<boolean | null>(null);
  const [solarPanels, setSolarPanels] = useState<boolean | null>(null);
  const [forbearance, setForbearance] = useState<boolean | null>(null);
  const [liens, setLiens] = useState<boolean | null>(null);
  const [lateMortgage, setLateMortgage] = useState<boolean | null>(null);
  const [farmActivity, setFarmActivity] = useState<boolean | null>(null);
  const [reinstated, setReinstated] = useState<boolean | null>(null);
  const [amountOwed, setAmountOwed] = useState('');
  const [dateOwed, setDateOwed] = useState('');
  const [assetSummary, setAssetSummary] = useState('');
  const [vaRelativeName, setVaRelativeName] = useState('');
  const [vaRelativeAddress, setVaRelativeAddress] = useState('');
  const [vaRelativePhone, setVaRelativePhone] = useState('');
  const [vaRelativeRelationship, setVaRelativeRelationship] = useState('');
  const [waterSource, setWaterSource] = useState('');
  const handleNext = () => {
    if (currentStep < STEPS.length - 1) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };
  const handleSubmit = () => {
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-363">
        <div className="max-w-2xl w-full bg-white rounded-2xl p-8 text-center shadow-lg" data-id="element-364">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-365">
            <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-366">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-367" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-368">
            Application Submitted!
          </h1>
          <p className="text-gray-600 mb-8" data-id="element-369">
            Your refinance mortgage application has been successfully submitted.
            Our team will review your information and contact you within 24-48
            hours.
          </p>
          <button onClick={() => navigate('/')} className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700" data-id="element-370">
            Return to Home
          </button>
        </div>
      </div>;
  }
  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        // Borrower Information
        return <div className="space-y-6" data-id="element-371">
            <SectionCard title="Personal Details" data-id="element-372">
              <div className="space-y-4" data-id="element-373">
                <FieldGrid data-id="element-374">
                  <YesNoToggle label="Veteran" value={isVeteran} onChange={setIsVeteran} data-id="element-375" />
                  <PercentField label="Disability Percentage" value={disabilityPercent} onChange={setDisabilityPercent} data-id="element-376" />
                </FieldGrid>
                <TextField label="Email Address" type="email" value={email} onChange={setEmail} required data-id="element-377" />
                <FieldGrid data-id="element-378">
                  <TextField label="Borrower Name" value={borrowerName} onChange={setBorrowerName} required data-id="element-379" />
                  <YesNoToggle label="Married" value={isMarried} onChange={setIsMarried} data-id="element-380" />
                </FieldGrid>
                <FieldGrid data-id="element-381">
                  <TextField label="SSN" value={ssn} onChange={setSsn} placeholder="XXX-XX-XXXX" required data-id="element-382" />
                  <DateField label="Date of Birth" value={dob} onChange={setDob} required data-id="element-383" />
                </FieldGrid>
                <TextField label="Credit Score" value={creditScore} onChange={setCreditScore} data-id="element-384" />
              </div>
            </SectionCard>

            <SectionCard title="Contact Information" data-id="element-385">
              <FieldGrid data-id="element-386">
                <PhoneField label="Home Phone" value={homePhone} onChange={setHomePhone} data-id="element-387" />
                <PhoneField label="Cell Phone" value={cellPhone} onChange={setCellPhone} required data-id="element-388" />
                <PhoneField label="Work Phone" value={workPhone} onChange={setWorkPhone} data-id="element-389" />
              </FieldGrid>
            </SectionCard>

            <SectionCard title="Current Address" data-id="element-390">
              <div className="space-y-4" data-id="element-391">
                <TextField label="Street Address" value={street} onChange={setStreet} required data-id="element-392" />
                <FieldGrid data-id="element-393">
                  <TextField label="City" value={city} onChange={setCity} required data-id="element-394" />
                  <SelectField label="State" value={state} onChange={setState} options={US_STATES} required data-id="element-395" />
                </FieldGrid>
                <FieldGrid data-id="element-396">
                  <TextField label="Zip Code" value={zip} onChange={setZip} required data-id="element-397" />
                  <TextField label="County" value={county} onChange={setCounty} data-id="element-398" />
                </FieldGrid>
              </div>
            </SectionCard>

            <SectionCard title="Subject Property" data-id="element-399">
              <div className="space-y-4" data-id="element-400">
                <TextField label="Property Address" value={propertyAddress} onChange={setPropertyAddress} required data-id="element-401" />
                <FieldGrid data-id="element-402">
                  <TextField label="City" value={propertyCity} onChange={setPropertyCity} required data-id="element-403" />
                  <SelectField label="State" value={propertyState} onChange={setPropertyState} options={US_STATES} required data-id="element-404" />
                </FieldGrid>
                <FieldGrid data-id="element-405">
                  <TextField label="Zip Code" value={propertyZip} onChange={setPropertyZip} required data-id="element-406" />
                  <TextField label="County" value={propertyCounty} onChange={setPropertyCounty} data-id="element-407" />
                </FieldGrid>
              </div>
            </SectionCard>
          </div>;
      case 1:
        // Employment & Income
        return <div className="space-y-6" data-id="element-408">
            <SectionCard title="Current Employer" data-id="element-409">
              <div className="space-y-4" data-id="element-410">
                <FieldGrid data-id="element-411">
                  <TextField label="Employer Name" value={employerName} onChange={setEmployerName} required data-id="element-412" />
                  <TextField label="Position / Title" value={position} onChange={setPosition} required data-id="element-413" />
                </FieldGrid>
                <FieldGrid data-id="element-414">
                  <TextField label="Years Employed" value={yearsEmployed} onChange={setYearsEmployed} required data-id="element-415" />
                  <CurrencyField label="Annual Income" value={income} onChange={setIncome} required data-id="element-416" />
                </FieldGrid>
                <RadioGroup label="Employment Type" value={employmentType} onChange={setEmploymentType} options={[{
                value: 'W2',
                label: 'W2'
              }, {
                value: '1099',
                label: '1099'
              }, {
                value: 'Self Employed',
                label: 'Self Employed'
              }]} layout="horizontal" required data-id="element-417" />
              </div>
            </SectionCard>

            <SectionCard title="Previous Employer" data-id="element-418">
              <div className="space-y-4" data-id="element-419">
                <FieldGrid data-id="element-420">
                  <TextField label="Employer Name" value={prevEmployerName} onChange={setPrevEmployerName} data-id="element-421" />
                  <TextField label="Position / Title" value={prevPosition} onChange={setPrevPosition} data-id="element-422" />
                </FieldGrid>
                <FieldGrid data-id="element-423">
                  <TextField label="Years Employed" value={prevYearsEmployed} onChange={setPrevYearsEmployed} data-id="element-424" />
                  <CurrencyField label="Annual Income" value={prevIncome} onChange={setPrevIncome} data-id="element-425" />
                </FieldGrid>
                <RadioGroup label="Employment Type" value={prevEmploymentType} onChange={setPrevEmploymentType} options={[{
                value: 'W2',
                label: 'W2'
              }, {
                value: '1099',
                label: '1099'
              }, {
                value: 'Self Employed',
                label: 'Self Employed'
              }]} layout="horizontal" data-id="element-426" />
              </div>
            </SectionCard>

            <SectionCard title="Additional Income" data-id="element-427">
              <FieldGrid data-id="element-428">
                <CurrencyField label="SSI" value={ssi} onChange={setSsi} data-id="element-429" />
                <CurrencyField label="Pension" value={pension} onChange={setPension} data-id="element-430" />
                <CurrencyField label="VA Disability" value={vaDisability} onChange={setVaDisability} data-id="element-431" />
                <CurrencyField label="Additional Income" value={additionalIncome} onChange={setAdditionalIncome} data-id="element-432" />
              </FieldGrid>
              <div className="mt-4" data-id="element-433">
                <TextField label="Next Pay Raise" value={nextPayRaise} onChange={setNextPayRaise} data-id="element-434" />
              </div>
            </SectionCard>

            <SectionCard title="Debts" data-id="element-435">
              <FieldGrid data-id="element-436">
                <CurrencyField label="Credit Cards (Monthly)" value={creditCards} onChange={setCreditCards} data-id="element-437" />
                <CurrencyField label="Auto Loans (Monthly)" value={autoLoans} onChange={setAutoLoans} data-id="element-438" />
                <CurrencyField label="Personal Loans (Monthly)" value={personalLoans} onChange={setPersonalLoans} data-id="element-439" />
                <CurrencyField label="Other Debt (Monthly)" value={otherDebt} onChange={setOtherDebt} data-id="element-440" />
              </FieldGrid>
            </SectionCard>
          </div>;
      case 2:
        // Co-Borrower
        return <div className="space-y-6" data-id="element-441">
            <SectionCard data-id="element-442">
              <CheckboxField label="No Co-Borrower" checked={noCoBorrower} onChange={setNoCoBorrower} data-id="element-443" />
            </SectionCard>

            {!noCoBorrower && <>
                <SectionCard title="Personal Information" data-id="element-444">
                  <div className="space-y-4" data-id="element-445">
                    <FieldGrid data-id="element-446">
                      <TextField label="Name" value={coBorrowerName} onChange={setCoBorrowerName} data-id="element-447" />
                      <YesNoToggle label="Married" value={coBorrowerMarried} onChange={setCoBorrowerMarried} data-id="element-448" />
                    </FieldGrid>
                    <FieldGrid data-id="element-449">
                      <TextField label="SSN" value={coBorrowerSsn} onChange={setCoBorrowerSsn} placeholder="XXX-XX-XXXX" data-id="element-450" />
                      <DateField label="Date of Birth" value={coBorrowerDob} onChange={setCoBorrowerDob} data-id="element-451" />
                    </FieldGrid>
                    <TextField label="Credit Score" value={coBorrowerCreditScore} onChange={setCoBorrowerCreditScore} data-id="element-452" />
                  </div>
                </SectionCard>

                <SectionCard title="Employment" data-id="element-453">
                  <div className="space-y-4" data-id="element-454">
                    <FieldGrid data-id="element-455">
                      <TextField label="Employer" value={coBorrowerEmployer} onChange={setCoBorrowerEmployer} data-id="element-456" />
                      <TextField label="Position" value={coBorrowerPosition} onChange={setCoBorrowerPosition} data-id="element-457" />
                    </FieldGrid>
                    <FieldGrid data-id="element-458">
                      <TextField label="Years Employed" value={coBorrowerYears} onChange={setCoBorrowerYears} data-id="element-459" />
                      <CurrencyField label="Annual Income" value={coBorrowerIncome} onChange={setCoBorrowerIncome} data-id="element-460" />
                    </FieldGrid>
                  </div>
                </SectionCard>

                <SectionCard title="Previous Employment" data-id="element-461">
                  <div className="space-y-4" data-id="element-462">
                    <FieldGrid data-id="element-463">
                      <TextField label="Employer" value={coBorrowerPrevEmployer} onChange={setCoBorrowerPrevEmployer} data-id="element-464" />
                      <TextField label="Position" value={coBorrowerPrevPosition} onChange={setCoBorrowerPrevPosition} data-id="element-465" />
                    </FieldGrid>
                    <FieldGrid data-id="element-466">
                      <TextField label="Years Employed" value={coBorrowerPrevYears} onChange={setCoBorrowerPrevYears} data-id="element-467" />
                      <CurrencyField label="Annual Income" value={coBorrowerPrevIncome} onChange={setCoBorrowerPrevIncome} data-id="element-468" />
                    </FieldGrid>
                  </div>
                </SectionCard>

                <SectionCard title="Additional Income" data-id="element-469">
                  <FieldGrid data-id="element-470">
                    <CurrencyField label="SSI" value={coBorrowerSsi} onChange={setCoBorrowerSsi} data-id="element-471" />
                    <CurrencyField label="Pension" value={coBorrowerPension} onChange={setCoBorrowerPension} data-id="element-472" />
                    <CurrencyField label="VA Disability" value={coBorrowerVaDisability} onChange={setCoBorrowerVaDisability} data-id="element-473" />
                    <CurrencyField label="Additional Income" value={coBorrowerAdditionalIncome} onChange={setCoBorrowerAdditionalIncome} data-id="element-474" />
                  </FieldGrid>
                  <div className="mt-4" data-id="element-475">
                    <TextField label="Next Pay Raise" value={coBorrowerNextPayRaise} onChange={setCoBorrowerNextPayRaise} data-id="element-476" />
                  </div>
                </SectionCard>
              </>}
          </div>;
      case 3:
        // Subject Property
        return <div className="space-y-6" data-id="element-477">
            <SectionCard title="Occupancy" data-id="element-478">
              <RadioGroup label="Property Use" value={occupancy} onChange={setOccupancy} options={[{
              value: 'Primary Residence',
              label: 'Primary Residence'
            }, {
              value: 'Second Home',
              label: 'Second Home'
            }, {
              value: 'Investment Property',
              label: 'Investment Property'
            }]} required data-id="element-479" />
            </SectionCard>

            <SectionCard title="Property Characteristics" data-id="element-480">
              <FieldGrid data-id="element-481">
                <TextField label="Year Built" value={yearBuilt} onChange={setYearBuilt} data-id="element-482" />
                <TextField label="Square Footage" value={squareFootage} onChange={setSquareFootage} data-id="element-483" />
              </FieldGrid>
            </SectionCard>

            <SectionCard title="Property Type" data-id="element-484">
              <div className="space-y-4" data-id="element-485">
                <RadioGroup label="Type" value={propertyType} onChange={setPropertyType} options={[{
                value: 'Condo',
                label: 'Condo'
              }, {
                value: 'Single Family Residence',
                label: 'Single Family Residence'
              }, {
                value: 'Townhouse',
                label: 'Townhouse'
              }, {
                value: 'Manufactured Home',
                label: 'Manufactured Home'
              }, {
                value: 'Mobile Home',
                label: 'Mobile Home'
              }, {
                value: '2-4 Unit',
                label: '2-4 Unit'
              }]} required data-id="element-486" />
                {propertyType === 'Condo' && <YesNoToggle label="Condo Approved?" value={condoApproved} onChange={setCondoApproved} data-id="element-487" />}
              </div>
            </SectionCard>
          </div>;
      case 4:
        // Current Mortgage
        return <div className="space-y-6" data-id="element-488">
            <SectionCard title="Current Mortgage Information" data-id="element-489">
              <div className="space-y-4" data-id="element-490">
                <FieldGrid data-id="element-491">
                  <DateField label="Last Refinance Date" value={lastRefinanceDate} onChange={setLastRefinanceDate} data-id="element-492" />
                  <TextField label="Purchase Year" value={purchaseYear} onChange={setPurchaseYear} data-id="element-493" />
                </FieldGrid>
                <FieldGrid data-id="element-494">
                  <CurrencyField label="Purchase Price" value={purchasePrice} onChange={setPurchasePrice} data-id="element-495" />
                  <CurrencyField label="Estimated Property Value" value={estimatedValue} onChange={setEstimatedValue} data-id="element-496" />
                </FieldGrid>
              </div>
            </SectionCard>

            <SectionCard title="Existing Loan" data-id="element-497">
              <div className="space-y-4" data-id="element-498">
                <TextField label="Mortgage Company" value={mortgageCompany} onChange={setMortgageCompany} data-id="element-499" />
                <FieldGrid data-id="element-500">
                  <CurrencyField label="Current Balance" value={currentBalance} onChange={setCurrentBalance} data-id="element-501" />
                  <CurrencyField label="Current Payment" value={currentPayment} onChange={setCurrentPayment} data-id="element-502" />
                </FieldGrid>
                <CurrencyField label="Client Estimated Value" value={clientEstimatedValue} onChange={setClientEstimatedValue} data-id="element-503" />
              </div>
            </SectionCard>

            <SectionCard title="Escrow Information" data-id="element-504">
              <div className="space-y-4" data-id="element-505">
                <YesNoToggle label="Escrowed" value={escrowed} onChange={setEscrowed} data-id="element-506" />
                <FieldGrid data-id="element-507">
                  <CurrencyField label="Property Taxes (Monthly)" value={propertyTaxes} onChange={setPropertyTaxes} data-id="element-508" />
                  <CurrencyField label="Insurance (Monthly)" value={insurance} onChange={setInsurance} data-id="element-509" />
                  <CurrencyField label="PMI (Monthly)" value={pmi} onChange={setPmi} data-id="element-510" />
                  <CurrencyField label="HOA (Monthly)" value={hoa} onChange={setHoa} data-id="element-511" />
                </FieldGrid>
              </div>
            </SectionCard>

            <SectionCard title="Current Loan Terms" data-id="element-512">
              <div className="space-y-4" data-id="element-513">
                <FieldGrid data-id="element-514">
                  <PercentField label="Interest Rate" value={interestRate} onChange={setInterestRate} data-id="element-515" />
                  <TextField label="Loan Term (Years)" value={loanTerm} onChange={setLoanTerm} data-id="element-516" />
                </FieldGrid>
                <RadioGroup label="Loan Structure" value={loanStructure} onChange={setLoanStructure} options={[{
                value: 'Fixed',
                label: 'Fixed'
              }, {
                value: 'Adjustable',
                label: 'Adjustable'
              }, {
                value: 'Interest Only',
                label: 'Interest Only'
              }]} layout="horizontal" data-id="element-517" />
                <RadioGroup label="Loan Type" value={loanType} onChange={setLoanType} options={[{
                value: 'FHA',
                label: 'FHA'
              }, {
                value: 'Conventional',
                label: 'Conventional'
              }, {
                value: 'VA',
                label: 'VA'
              }]} layout="horizontal" data-id="element-518" />
              </div>
            </SectionCard>

            <SectionCard title="Second Mortgage / HELOC" data-id="element-519">
              <div className="space-y-4" data-id="element-520">
                <YesNoToggle label="Has Second Mortgage?" value={hasSecondMortgage} onChange={setHasSecondMortgage} data-id="element-521" />
                {hasSecondMortgage && <>
                    <TextField label="Lender Name" value={secondLender} onChange={setSecondLender} data-id="element-522" />
                    <FieldGrid data-id="element-523">
                      <CurrencyField label="Balance" value={secondBalance} onChange={setSecondBalance} data-id="element-524" />
                      <TextField label="Year Opened" value={secondYearOpened} onChange={setSecondYearOpened} data-id="element-525" />
                    </FieldGrid>
                    <FieldGrid data-id="element-526">
                      <CurrencyField label="Payment" value={secondPayment} onChange={setSecondPayment} data-id="element-527" />
                      <PercentField label="Interest Rate" value={secondRate} onChange={setSecondRate} data-id="element-528" />
                    </FieldGrid>
                    <TextField label="Term" value={secondTerm} onChange={setSecondTerm} data-id="element-529" />
                    <RadioGroup label="Loan Structure" value={secondStructure} onChange={setSecondStructure} options={[{
                  value: 'Fixed',
                  label: 'Fixed'
                }, {
                  value: 'Adjustable',
                  label: 'Adjustable'
                }, {
                  value: 'Interest Only',
                  label: 'Interest Only'
                }]} layout="horizontal" data-id="element-530" />
                    <YesNoToggle label="Pulled Cash Out Within Last 12 Months?" value={helocCashOut} onChange={setHelocCashOut} data-id="element-531" />
                  </>}
              </div>
            </SectionCard>
          </div>;
      case 5:
        // Credit & Assets
        return <div className="space-y-6" data-id="element-532">
            <SectionCard title="Credit & Property Questions" data-id="element-533">
              <div className="space-y-4" data-id="element-534">
                <YesNoToggle label="Foreclosure Within Last 7 Years?" value={foreclosure} onChange={setForeclosure} data-id="element-535" />
                <YesNoToggle label="Bankruptcy Within Last 7 Years?" value={bankruptcy} onChange={setBankruptcy} data-id="element-536" />
                {bankruptcy && <RadioGroup label="Bankruptcy Chapter" value={bankruptcyChapter} onChange={setBankruptcyChapter} options={[{
                value: 'Chapter 7',
                label: 'Chapter 7'
              }, {
                value: 'Chapter 13',
                label: 'Chapter 13'
              }]} layout="horizontal" data-id="element-537" />}
                <YesNoToggle label="Child Support Obligation?" value={childSupport} onChange={setChildSupport} data-id="element-538" />
                <YesNoToggle label="Loan Modification?" value={loanModification} onChange={setLoanModification} data-id="element-539" />
                <YesNoToggle label="Deferred Interest?" value={deferredInterest} onChange={setDeferredInterest} data-id="element-540" />
                <YesNoToggle label="Solar Panels?" value={solarPanels} onChange={setSolarPanels} data-id="element-541" />
                <YesNoToggle label="Mortgage Forbearance?" value={forbearance} onChange={setForbearance} data-id="element-542" />
                <YesNoToggle label="Liens Attached To Property?" value={liens} onChange={setLiens} data-id="element-543" />
                <YesNoToggle label="Late Mortgage Payments?" value={lateMortgage} onChange={setLateMortgage} data-id="element-544" />
                <YesNoToggle label="Farm Activity?" value={farmActivity} onChange={setFarmActivity} data-id="element-545" />
                <YesNoToggle label="Reinstated?" value={reinstated} onChange={setReinstated} data-id="element-546" />
                <FieldGrid data-id="element-547">
                  <CurrencyField label="Amount Owed" value={amountOwed} onChange={setAmountOwed} data-id="element-548" />
                  <DateField label="Date Owed" value={dateOwed} onChange={setDateOwed} data-id="element-549" />
                </FieldGrid>
              </div>
            </SectionCard>

            <SectionCard title="Assets" data-id="element-550">
              <TextField label="Asset Summary" value={assetSummary} onChange={setAssetSummary} placeholder="Describe your assets..." data-id="element-551" />
            </SectionCard>

            <SectionCard title="VA Specific Information" data-id="element-552">
              <div className="space-y-4" data-id="element-553">
                <h4 className="font-medium text-gray-900" data-id="element-554">
                  VA Non-Living Relative
                </h4>
                <TextField label="Name" value={vaRelativeName} onChange={setVaRelativeName} data-id="element-555" />
                <TextField label="Address" value={vaRelativeAddress} onChange={setVaRelativeAddress} data-id="element-556" />
                <PhoneField label="Phone Number" value={vaRelativePhone} onChange={setVaRelativePhone} data-id="element-557" />
                <TextField label="Relationship" value={vaRelativeRelationship} onChange={setVaRelativeRelationship} data-id="element-558" />
              </div>
            </SectionCard>

            <SectionCard title="Water Source" data-id="element-559">
              <RadioGroup label="Water Source" value={waterSource} onChange={setWaterSource} options={[{
              value: 'Well Water',
              label: 'Well Water'
            }, {
              value: 'City Water',
              label: 'City Water'
            }]} layout="horizontal" data-id="element-560" />
            </SectionCard>
          </div>;
      case 6:
        // Review
        return <div className="space-y-6" data-id="element-561">
            <SectionCard data-id="element-562">
              <div className="text-center py-8" data-id="element-563">
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-564">
                  Review Your Application
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-565">
                  Please review all the information you've provided. You can go
                  back to any step to make changes.
                </p>
                <div className="bg-blue-50 rounded-lg p-6 text-left" data-id="element-566">
                  <h3 className="font-semibold text-gray-900 mb-2" data-id="element-567">
                    Application Summary
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700" data-id="element-568">
                    <p data-id="element-569">
                      <strong data-id="element-570">Borrower:</strong>{' '}
                      {borrowerName || 'Not provided'}
                    </p>
                    <p data-id="element-571">
                      <strong data-id="element-572">Email:</strong> {email || 'Not provided'}
                    </p>
                    <p data-id="element-573">
                      <strong data-id="element-574">Property Type:</strong>{' '}
                      {propertyType || 'Not provided'}
                    </p>
                    <p data-id="element-575">
                      <strong data-id="element-576">Current Balance:</strong>{' '}
                      {currentBalance ? `$${parseFloat(currentBalance).toLocaleString()}` : 'Not provided'}
                    </p>
                    <p data-id="element-577">
                      <strong data-id="element-578">Loan Type:</strong> {loanType || 'Not provided'}
                    </p>
                  </div>
                </div>
              </div>
            </SectionCard>
          </div>;
      default:
        return null;
    }
  };
  return <WizardShell steps={STEPS} currentStep={currentStep} onStepChange={setCurrentStep} onBack={handleBack} onNext={handleNext} onSubmit={handleSubmit} canGoBack={currentStep > 0} canGoNext={true} isLastStep={currentStep === STEPS.length - 1} data-id="element-579">
      {renderStepContent()}
    </WizardShell>;
}